"use client"

import { ArrowLeft } from "lucide-react"
import { Button } from "@/components/ui/button"

export function GoBackButton() {
  return (
    <Button
      variant="ghost"
      onClick={() => window.history.back()}
      className="font-display text-[var(--tls-fg-muted)] hover:text-[var(--tls-fg-strong)] transition-colors"
    >
      <ArrowLeft className="size-4 mr-2" />
      Go back
    </Button>
  )
}
